import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress'
import { Box } from '@mui/material';

export default function LoadingCompoment<T>(props: {
  children: React.ReactNode
  loadingFunction: () => void
  watchEffectProperty: [T] | []
}) {

  const [isLoading, setLoading] = React.useState(true)

  React.useEffect(() => {
    loading()
  }, props.watchEffectProperty)

  /** ロードするイベント */
  const loading = async () => {
    setLoading(true)
    await props.loadingFunction()
    setLoading(false)
  }

  if (isLoading) return (
    <Box
      sx={{
        textAlign: "center"
      }
      }>
      <CircularProgress />
    </Box>
  )
  return (
    <>
      {props.children}
    </>
  )
}
